var map = {
	"./en": [
		"e312"
	],
	"./en.json": [
		"e312"
	],
	"./ja": [
		"6a87",
		"lang-ja"
	],
	"./ja.json": [
		"6a87"
	],
	"./zh-TW": [
		"e3bc"
	],
	"./zh-TW.json": [
		"e3bc"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;